import { Reveal, SectionLabel } from "@/components/landing/Reveal";
import { EligibilityButton } from "@/components/landing/EligibilityButton";

export const SolutionSection = () => (
  <section className="relative overflow-hidden px-4 py-16 diag-grid sm:px-8 lg:py-24" data-testid="solution-section">
    <div className="pointer-events-none absolute left-1/2 top-0 h-64 w-[40rem] -translate-x-1/2 rounded-full bg-em1/10 blur-[120px]" />
    <div className="relative z-10 mx-auto max-w-4xl text-center">
      <Reveal>
        <SectionLabel className="justify-center">The Offline Advantage</SectionLabel>
        <h2 className="mt-4 font-display text-4xl font-bold uppercase leading-[0.95] tracking-tight text-offwhite sm:text-6xl">
          BullsEdge Academy — Ahmedabad's Classroom for{" "}
          <span className="text-em2">Serious Traders</span>
        </h2>
        <p className="mx-auto mt-6 max-w-2xl text-base leading-relaxed text-mutedgreen sm:text-lg">
          No more random videos. No more fake tips. No more figuring it out alone.
          At BullsEdge, you sit in a real classroom, watch live trading with your
          mentor, and get one-on-one guidance — from your very first class to your
          most advanced strategy. Plus, every session is recorded, so you can
          revisit anything you missed.
        </p>
        <div className="mt-8 flex justify-center">
          <EligibilityButton size="lg" testId="solution-inquire-btn" />
        </div>
      </Reveal>
    </div>
  </section>
);
